import {
  PostPurchaseParamsStepFieldType,
  ProductPricingModel,
} from '@portals/types';

export enum ProductTypeEnum {
  Physical = 'physical',
  Digital = 'digital',
}

export interface Product {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  category: string | null;
  subtitle: string | null;
  description: string;
  image_url: string | null;
  device_model: {
    id: string;
    name: string;
    active: boolean;
  } | null;
  tax_group_id: string;
  product_type: ProductTypeEnum;
  in_store: boolean;
  editable: boolean;
  archived: boolean;
  license_data: string | null;
  post_purchase_parameters: Array<PostPurchaseParamsStepFieldType>;
  manufacturer: {
    display_name: string;
    logo?: string;
  };
  pricing_model: ProductPricingModel;
  sku: string | null;
  usage_based_display_name: string | null;
  usage_based_telemetry_key: string | null;
  usage_based_unit_name: string | null;
}

export type ProductUsageBasedFieldsNames = keyof Pick<
  Product,
  | 'usage_based_display_name'
  | 'usage_based_telemetry_key'
  | 'usage_based_unit_name'
>;

export type PublishableProduct = any;
